import keyMirror from 'react-utils/keyMirror';
const notificationTypes = keyMirror({
  WEEKLY: null,
  MONTHLY: null,
  LEAD_REVISIT: null,
  FORM_AND_LANDING_PAGE_SUBMISSION: null,
  CALENDAR: null,
  SUCCESS_REPLY: null,
  PROJECTS: null
});
export default notificationTypes;